<template>
  <a-modal :visible="visible" title="关联优惠券" width="1000px" :maskClosable="false" @ok="handleOk"
    @cancel="handleCancel" okText="确认" cancelText="取消">
    <div class="link-modal-content">
      <div class="date-header">
        <span class="date-label">选择日期：</span>
        <span class="date-value">{{ formattedDate }}</span>
      </div>

      <a-input v-model:value="searchName" placeholder="输入姓名过滤" style="width: 300px; margin-bottom: 16px;" allow-clear>
        <template #prefix>
          <SearchOutlined />
        </template>
      </a-input>

      <a-table :columns="columns" :data-source="filteredOrderList" rowKey="id" :pagination="false"
        :scroll="{ y: 400 }" size="small" bordered :rowClassName="getRowClassName">
        <template #operation="{ record }">
          <a-button type="primary" size="small" @click="handleSelect(record)">选择</a-button>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { SearchOutlined } from "@ant-design/icons-vue";
import moment from "moment";

export default {
  name: "LinkCouponModal",
  components: {
    SearchOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderList: {
      type: Array,
      default: () => [],
    },
    currentDate: {
      type: String,
      default: "",
    },
    currentRecord: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:visible", "select", "cancel"],
    data() {
    return {
      searchName: "",
      columns: [
        { title: "客户", dataIndex: "customerName", key: "customerName", width: 120, align: "center" },
        { title: "收据编号", dataIndex: "receiptNumber", key: "receiptNumber", width: 120, align: "center" },
        { title: "医保编号", dataIndex: "medicalInsuranceCode", key: "medicalInsuranceCode", width: 120, align: "center" },
        { title: "订单日期", dataIndex: "orderDate", key: "orderDate", width: 140, align: "center" },
        { title: "现金", dataIndex: "xianjin", key: "xianjin", width: 100, align: "center" },
        { title: "总金额", dataIndex: "zongRuzhang", key: "zongRuzhang", width: 100, align: "center" },
        { title: "操作", dataIndex: "operation", key: "operation", width: 80, align: "center", slots: { customRender: "operation" } },
      ],
    };
  },
  computed: {
    formattedDate() {
      if (!this.currentDate) return "";
      return moment(this.currentDate, "YYYY-M-D").format("YYYY-MM-DD");
    },
    filteredOrderList() {
      let list = this.orderList;
      if (this.searchName) {
        list = list.filter((item) => {
          const name = item.customerName || "";
          const medicalCode = item.medicalInsuranceCode || "";
          return name.includes(this.searchName) || medicalCode.includes(this.searchName);
        });
      }
      if (this.currentRecord && this.currentRecord.actualUser) {
        const currentName = this.currentRecord.actualUser;
        list = [...list].sort((a, b) => {
          const aMatch = a.customerName === currentName ? 0 : 1;
          const bMatch = b.customerName === currentName ? 0 : 1;
          return aMatch - bMatch;
        });
      }
      return list;
    },
  },
  methods: {
    handleOk() {
      // No-op, handled by handleSelect
    },
    handleCancel() {
      this.$emit("update:visible", false);
      this.searchName = "";
      this.$emit("cancel");
    },
    handleSelect(record) {
      this.$emit("select", record);
    },
    getRowClassName(record) {
      if (this.currentRecord && this.currentRecord.actualUser) {
        if (record.customerName === this.currentRecord.actualUser) {
          return "highlight-row";
        }
      }
      return "";
    },
  },
};
</script>

<style scoped>
.link-modal-content {
  padding: 10px 0;
}

.date-header {
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
}

.date-label {
  color: #666;
  margin-right: 8px;
}

.date-value {
  color: #1890ff;
  font-weight: 500;
}
</style>
